import { Chip, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { Util } from '../../util/Util';
import { NUMBER_FILTER_OPTIONS, TEXT_FILTER_OPTIONS } from '../../util/constants';
import type { WalletRecordRow } from './walletTypes';
import { walletSignedAmount } from './walletTypes';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export const walletRecordColumns = (
  t: Translate,
  options?: { onClientClick?: (row: WalletRecordRow) => void },
): MRT_ColumnDef<WalletRecordRow>[] => [
  {
    header: t('common:tables.date'),
    accessorKey: 'date',
    Cell: ({ cell }) => {
      const value = String(cell.getValue() ?? '');
      return value ? Util.formatDate(value, 'medium') : '—';
    },
  },
  {
    header: t('common:tables.client'),
    accessorKey: 'client_name',
    filterFn: 'contains',
    columnFilterModeOptions: TEXT_FILTER_OPTIONS,
    Cell: ({ cell, row }) => {
      const name = String(cell.getValue() ?? '');
      if (!options?.onClientClick) return name;
      return (
        <button
          type="button"
          style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => options.onClientClick?.(row.original)}
        >
          {name}
        </button>
      );
    },
  },
  {
    header: t('common:wallet.type'),
    accessorKey: 'type',
    Cell: ({ cell }) => {
      const value = String(cell.getValue() ?? '').toUpperCase();
      const isDebit = value === 'DEBIT';
      return (
        <Chip
          size="small"
          label={isDebit ? t('common:wallet.debit') : t('common:wallet.credit')}
          color={isDebit ? 'error' : 'success'}
          variant="outlined"
        />
      );
    },
  },
  {
    header: t('common:tables.amount'),
    accessorKey: 'amount',
    accessorFn: (row) => walletSignedAmount(row),
    Cell: ({ row }) => {
      const value = walletSignedAmount(row.original);
      return (
        <Typography variant="body2" color={value < 0 ? 'error.main' : 'success.main'} fontWeight={700}>
          {Util.formatNumber(value)}
        </Typography>
      );
    },
    filterFn: 'greaterThanOrEqualTo',
    columnFilterModeOptions: NUMBER_FILTER_OPTIONS,
  },
  {
    header: t('common:wallet.tag'),
    accessorKey: 'tag',
    filterFn: 'contains',
    columnFilterModeOptions: TEXT_FILTER_OPTIONS,
  },
  {
    header: t('common:tables.mode'),
    accessorKey: 'mode_name',
    Cell: ({ cell }) => String(cell.getValue() ?? '') || '—',
  },
  {
    header: t('common:wallet.sourceWallet'),
    accessorKey: 'source_client_name',
    Cell: ({ cell }) => String(cell.getValue() ?? '') || '—',
  },
  {
    header: t('common:wallet.ref'),
    accessorKey: 'ref',
  },
  {
    header: t('common:tables.user'),
    accessorKey: 'user',
  },
  {
    header: t('common:wallet.description'),
    accessorKey: 'description',
    Cell: ({ cell }) => String(cell.getValue() ?? '') || '—',
  },
];
